export default function WhyAlexeySivko() {
  const stats = [
    { icon: 'ri-calendar-check-line', value: '18+', label: 'лет практики' },
    { icon: 'ri-building-2-line', value: '100+', label: 'корпоративных проектов' },
    { icon: 'ri-presentation-line', value: '450+', label: 'тренингов' },
    { icon: 'ri-user-star-line', value: '4500+', label: 'участников' },
  ];

  const advantages = [
    { icon: 'ri-briefcase-line', title: 'Практикующий консультант', desc: 'Не только обучаю, но и лично консультирую собственников бизнеса, помогаю выстраивать клиентский сервис и сопровождаю сложные проекты.' },
    { icon: 'ri-global-line', title: 'География проектов', desc: 'Работаю с компаниями Беларуси, России, Казахстана и Израиля. Понимаю специфику разных рынков и менталитетов.' },
    { icon: 'ri-user-voice-line', title: '«Играющий тренер»', desc: 'Продолжаю лично работать с клиентами, консультировать и сопровождать сделки. Обучаю не теории, а современной практике коммуникации.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-user-star-line"></i>
            О тренере
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему выбирают Алексея Сивко
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            18+ лет в коммуникации с клиентами. Более 100 корпоративных проектов. Не теоретик — практик, который продолжает лично работать с клиентами.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-start max-w-5xl mx-auto mb-12">
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl p-6 border border-gray-100">
              <div className="w-20 h-20 rounded-full overflow-hidden bg-teal-600 mx-auto mb-4">
                <img
                  src="https://static.readdy.ai/image/045fa1b133efd9567759baab28602a6d/d5f5f47c7d94e3dc67c5ef073553230f.jpeg"
                  alt="Алексей Сивко"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-1">Алексей Сивко</h3>
              <p className="text-sm text-teal-600 text-center font-medium mb-6">Бизнес-тренер, эксперт по коммуникации с клиентами</p>

              <div className="space-y-3">
                {stats.map((item, i) => (
                  <div key={i} className="flex items-center gap-3 bg-gray-50 rounded-lg p-3 border border-gray-100">
                    <div className="w-10 h-10 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-teal-600 text-base`}></i>
                    </div>
                    <div>
                      <div className="text-lg font-bold text-gray-900">{item.value}</div>
                      <div className="text-xs text-gray-500">{item.label}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 space-y-4">
            {advantages.map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 transition-colors group">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-teal-600/15 transition-colors">
                    <i className={`${item.icon} text-teal-600 text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900 mb-1.5">{item.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-10 text-center">
          <p className="text-lg md:text-xl text-white leading-relaxed font-medium">
            Я остаюсь «играющим тренером». Продолжаю лично работать с клиентами, консультировать собственников и сопровождать сложные проекты. Поэтому обучаю не теории, а современной практике — тому, что работает здесь и сейчас.
          </p>
        </div>
      </div>
    </section>
  );
}